/**
 * @generated SignedSource<<594f3bf579a9b8dbb314665507346fff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bookingId",
        "variableName": "bookingId"
      }
    ],
    "kind": "ScalarField",
    "name": "sendTicketToEmail",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendTicketToEmailQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendTicketToEmailQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "77e3c6d0afb9c5ab21a7e77e9ab04465",
    "id": null,
    "metadata": {},
    "name": "SendTicketToEmailQuery",
    "operationKind": "query",
    "text": "query SendTicketToEmailQuery(\n  $bookingId: String!\n) {\n  sendTicketToEmail(bookingId: $bookingId)\n}\n"
  }
};
})();

node.hash = "9b59eb843f84e3111d29fde856ad8ae8";

module.exports = node;
